<template>
    <!-- Container para toda la página: ******************************************************* -->
    <v-container fill-height fluid class="pets">
        <!-- Layout para toda la página: *********************************************************** -->
        <v-layout align-center justify-center>
            <!-- Flex para la ventana: **************************************************************** -->
            <v-flex xs12 sm10 elevation-6>
                <div class="sub-window">
                    <v-toolbar dense dark color="light-blue darken-4">
                        <v-toolbar-title><v-icon>mdi-magnify</v-icon>&nbsp;Búsqueda de mascotas&nbsp;&nbsp;</v-toolbar-title>
                        
                        <v-spacer></v-spacer>
                        <v-toolbar-items class="hidden-sm-and-down">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn text @click="onClose" v-on="on">
                                        <v-icon>mdi-close</v-icon>
                                    </v-btn>
                                </template>
                                <span>Cerrar</span>
                            </v-tooltip>
                        </v-toolbar-items>

                        <!-- Menú lateral para dispositivos con ventanas chicas: -->
                        <v-menu offset-y>
                            <template v-slot:activator="{ on }">
                                <v-btn icon v-on="on" class="hidden-md-and-up">
                                    <v-icon>mdi-dots-vertical</v-icon>
                                </v-btn>
                            </template>
                            <v-list color="grey lighten-4">
                                <v-divider></v-divider>
                                <v-list-item @click="onClose">
                                    <v-list-item-title>
                                        <v-icon color="red">mdi-close</v-icon>&nbsp; Cerrar
                                    </v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </v-toolbar>

                    <!-- Container para lista de usuarios y usuario seleccionado: -->
                    <v-container>
                        <v-row>
                            <v-col cols="4">
                                <v-checkbox
                                    dense
                                    label="Vacunaciones pendientes"
                                    v-model="bPendingVaxes"
                                    color="purple accent-4"
                                    @change="onPendingVaxes"
                                    :disabled="bPendingDewormings || bMembership || bRegistrationDate || bSpecies"
                                ></v-checkbox>
                            </v-col>
                            <v-col cols="4">
                                <v-checkbox
                                    dense
                                    label="Desparacitaciones pendientes"
                                    v-model="bPendingDewormings"
                                    color="purple accent-4"
                                    @change="onPendingDewormings"
                                    :disabled="bPendingVaxes || bMembership || bRegistrationDate || bSpecies"
                                ></v-checkbox>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="2">
                                <v-checkbox
                                    dense
                                    label="Tipo de membresía"
                                    v-model="bMembership"
                                    color="purple accent-4"
                                    @change="onMembership"
                                    :disabled="bPendingDewormings || bPendingVaxes"
                                ></v-checkbox>
                            </v-col>
                            <v-col cols="3">
                                <v-select
                                    dense
                                    prepend-icon="mdi-wallet-membership"
                                    :items="memberships"
                                    item-text="membresia"
                                    item-value="tipoid"
                                    v-model="membershipID"
                                    label="Tipo de membresía"
                                    :disabled="!bMembership"
                                    color="light-blue darken-4"
                                    item-color="light-blue darken-4"
                                ></v-select>
                            </v-col>
                            
                        </v-row>
                        <v-row>
                            <v-col cols="2">
                                <v-checkbox
                                    dense
                                    label="Fecha de registro"
                                    v-model="bRegistrationDate"
                                    color="purple accent-4"
                                    @change="onRegistrationDate"
                                    :disabled="bPendingDewormings || bPendingVaxes"
                                ></v-checkbox>
                            </v-col>
                            <v-col cols="3">
                                <v-menu
                                    v-model="bMenuRegistrationFrom"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px"
                                    :disabled="!bRegistrationDate"
                                >
                                    <template
                                        v-slot:activator="{
                                            on,
                                        }"
                                    >
                                        <v-text-field
                                            :dense="bDense"
                                            color="light-blue darken-4"
                                            v-model="registrationDateFrom"
                                            label="Entre"
                                            prepend-icon="mdi-calendar-month"
                                            readonly
                                            :disabled="!bRegistrationDate"
                                            v-on="on"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        color="light-blue darken-2"
                                        v-model="registrationDateFrom"
                                        @input="bMenuRegistrationFrom = false"
                                    ></v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col cols="3">
                                <v-menu
                                    v-model="bMenuRegistrationTo"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px"
                                    :disabled="!bRegistrationDate"
                                >
                                    <template
                                        v-slot:activator="{
                                            on,
                                        }"
                                    >
                                        <v-text-field
                                            :dense="bDense"
                                            color="light-blue darken-4"
                                            v-model="registrationDateTo"
                                            label="y"
                                            prepend-icon="mdi-calendar-month"
                                            readonly
                                            :disabled="!bRegistrationDate"
                                            v-on="on"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        color="light-blue darken-2"
                                        v-model="registrationDateTo"
                                        @input="bMenuRegistrationTo = false"
                                    ></v-date-picker>
                                </v-menu>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="2">
                                <v-checkbox
                                    dense
                                    label="País"
                                    v-model="bCountry"
                                    color="purple accent-4"
                                    @change="onCountry"
                                ></v-checkbox>
                            </v-col>
                            <v-col cols="3">
                                <v-select
                                    dense
                                    prepend-icon="mdi-earth"
                                    :items="countries"
                                    item-text="pais"
                                    item-value="paisid"
                                    v-model="countryID"
                                    label="País"
                                    :disabled="!bCountry"
                                    color="light-blue darken-4"
                                    item-color="purple accent-4"
                                    @change="onSelectCountry"
                                ></v-select>
                            </v-col>
                            <v-col cols="3">
                                <v-select
                                    dense
                                    prepend-icon="mdi-map-marker"
                                    :items="states"
                                    item-text="estado"
                                    item-value="estadoid"
                                    v-model="stateID"
                                    label="Estado"
                                    color="light-blue darken-4"
                                    item-color="light-blue darken-4"
                                    no-data-text="Seleccione un país"
                                    :disabled="countryID === 0"
                                ></v-select>
                            </v-col>              
                        </v-row>
                        <v-row>
                            <v-col cols="2">
                                <v-checkbox
                                    dense
                                    label="Especie"
                                    v-model="bSpecies"
                                    color="purple accent-4"
                                    @change="onSpecies"
                                    :disabled="bPendingDewormings || bPendingVaxes"
                                ></v-checkbox>
                            </v-col>
                            <v-col cols="3">
                                <v-select
                                    dense
                                    prepend-icon="mdi-dog-side"
                                    :items="species"
                                    item-text="especie"
                                    item-value="especieid"
                                    v-model="speciesID"
                                    label="Especie"
                                    :disabled="!bSpecies"
                                    color="light-blue darken-4"
                                    item-color="purple accent-4"
                                    @change="onSelectSpecies"
                                ></v-select>
                            </v-col>
                            <v-col cols="3">
                                <v-select
                                    dense
                                    prepend-icon="mdi-dog"
                                    :items="breedsSpanish"
                                    item-text="raza"
                                    item-value="razaid"
                                    v-model="breedID"
                                    label="Raza"
                                    color="light-blue darken-4"
                                    item-color="light-blue darken-4"
                                    no-data-text="Seleccione ua especie"
                                    :disabled="speciesID === 0"
                                ></v-select>
                            </v-col> 
                            <v-col cols="4">
                                <v-btn
                                    color="purple accent-4"
                                    class="text-none"
                                    text
                                    @click="onSearch"
                                ><v-icon>mdi-magnify</v-icon>Buscar </v-btn>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                                <v-card class="mx-auto" height="300">
                                    <v-toolbar height="30" color="light-blue lighten-1" flat>
                                        <v-icon mdi-paw></v-icon>
                                        <v-toolbar-title class="my-list-title">&nbsp; Resultado de la búsqueda</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-toolbar-items>
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on }">
                                                    <v-btn text :disabled="selectedResult.length === 0" @click="onPet" v-on="on">
                                                        <v-icon>mdi-magnify</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Ver</span>
                                            </v-tooltip>
                                        </v-toolbar-items>
                                    </v-toolbar>
                                    <v-data-table
                                        fixed-header
                                        :headers="clientTableHeader"
                                        :items="petSearchResults"
                                        v-model="selectedResult"
                                        item-key="mascotaid"
                                        locale="es-MX"
                                        hide-default-footer
                                        no-data-text=""
                                        :show-select="true"
                                        single-select
                                        dense
                                        :items-per-page="petSearchResults.length"
                                        height="270"
                                    ></v-data-table>
                                </v-card>
                            </v-col>
                        </v-row>

                        <!-- Modal para pedir que se seleccionen los parámetros adecuados para la búsqueda: *********************************** -->
                        <v-row row justify-center>
                            <v-dialog v-model="bDlgError" persistent :width="errorModalWidth">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="orange darken-4" dark flat>
                                        <v-toolbar-title
                                            class="my-list-title"
                                        >Información para búsqueda incompleta</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-alert-circle-outline</v-icon>
                                    </v-toolbar>
                                    <v-card-title>
                                        <v-container>
                                            <v-layout row>
                                                <v-flex xs12 class="d-flex justify-center">
                                                    <v-icon
                                                        large
                                                        color="orange darken-2"
                                                    >mdi-alert-circle</v-icon>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex
                                                    xs12
                                                    class="d-flex justify-center"
                                                >{{ errorMessage }}</v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-title>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="bDlgError = false"
                                        >OK</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-row>
                        <!-- Termina modal para pedir que se seleccionen los parámetros adecuados para la búsqueda *********************************** -->

                        
                        <!-- Modal para informar que no hubo resultados en la búsqueda: *********************************** -->
                        <v-row>
                            <v-dialog v-model="bShowNotFoundAlert" persistent max-width="30%">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="teal" dark flat>
                                        <v-toolbar-title class="my-list-title">Búsqueda de Usuarios</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>search</v-icon>
                                    </v-toolbar>
                                    <v-card-text>
                                        <v-container>
                                            <v-layout row>
                                                <v-flex xs12 class="d-flex justify-center">
                                                    <v-icon large color="orange darken-2">warning</v-icon>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex
                                                    xs12
                                                    class="d-flex justify-center"
                                                >No hay usuarios registrados con ese nombre.</v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="bShowNotFoundAlert = false"
                                        >OK</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-row>
                        <!-- Termina Modal para informar que no hubo resultados en la búsqueda *************************** -->

                        <!-- Modal para ver una mascota: ********************************-->
                        <v-row v-if="showPetDlg">
                            <v-dialog v-model="showPetDlg" persistent width="90%">
                                <mascota></mascota>
                            </v-dialog>
                        </v-row>
                        <!-- Termina modal para ver una mascota ********************************-->


                    </v-container>
                </div>
            </v-flex>
            <!-- Fin Flex para la ventana **************************************************************** -->
        </v-layout>
        <!-- Fin Layout para toda la página *********************************************************** -->
        <v-overlay :value="waitCursor">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </v-container>
    <!-- Fin container para toda la página ********************************************* -->
</template>
<script>
import { mapGetters } from 'vuex';
import Mascota from '@/components/Mascota';

export default {
    name: 'pets',
    data() {
        return {
            bDense: false,
            drawer: false,

            bMembership: false,
            membershipID: 0,
            
            bRegistrationDate: false,
            bMenuRegistrationFrom: false,
            registrationDateFrom: "",
            bMenuRegistrationTo: false,
            registrationDateTo: "",

            bPendingVaxes: false,
            bPendingDewormings: false,

            bCountry: false,
            countryID: 0,
            stateID: 0,

            bSpecies: false,
            speciesID: 0,
            breedID: 0,

            bDlgError: false,
            errorMessage: '',
            bShowNotFoundAlert: false, //Indica si se debe mostrar el diálogo que indica que no hubo resultados en la búsqueda.

            memberships: [
                {
                    tipoid: 2,
                    membresia: 'Básica',
                },
                {
                    tipoid: 3,
                    membresia: 'Premium',
                }
            ],

            clientTableHeader: [
                {
                    text: 'Núm. Usuario',
                    sortable: true,
                    align: 'right',
                    value: 'usuarioid'
                },
                {
                    text: 'Desde',
                    sortable: true,
                    align: 'center',
                    value: 'registro'
                },
                {
                    text: 'País',
                    sortable: true,
                    align: 'left',
                    value: 'pais'
                },
                {
                    text: 'Estado',
                    sortable: true,
                    align: 'left',
                    value: 'estado'
                },
                {
                    text: 'Especie',
                    sortable: true,
                    align: 'left',
                    value: 'especie'
                },
                {
                    text: 'Raza',
                    sortable: true,
                    align: 'left',
                    value: 'raza'
                },
                {
                    text: 'Edad',
                    sortable: true,
                    align: 'center',
                    value: 'edad'
                },
                {
                    text: 'Tipo de Usuario',
                    sortable: true,
                    align: 'left',
                    value: 'tipousuario'
                },
            ],
            selectedResult: [],

        };
    },
    created() {
        this.petSearchResults = [];
    },
    
    methods: {
        onClose() {
            this.$router.push('/');
        },

        onRegistrationDate(){
            if (!this.bRegistrationDate)
            {
                this.registrationDateFrom = "";
                this.registrationDateTo = "";
            }
        },

        onMembership(){
            this.membershipID = 0;
        },

        onPendingVaxes(){},
        onPendingDewormings(){},

        onCountry(){
            this.countryID = 0;
            this.stateID = 0;
        },

        onSelectCountry(){
            this.$store.dispatch('fetchStates', this.countryID);
        },

        onSpecies(){
            this.speciesID = 0;
            this.breedID = 0;
        },

        onSelectSpecies(){
            this.$store.dispatch('getBreedsSpanish', this.speciesID);
        },

        onSearch()
        {
            this.selectedResult = [];
            
            if (this.bMembership && this.membershipID === 0)
            {
                this.bDlgError = true;
                this.errorMessage = 'Seleccione un tipo de membresía.';
            }
            else
            if (this.bRegistrationDate && ((this.registrationDateFrom === null) || (this.registrationDateTo === null)))
            {
                this.bDlgError = true;
                this.errorMessage = 'Seleccione un rango de fechas para la búsqueda por fecha de registro.';
            }
            else
            if (this.registrationDateFrom > this.registrationDateTo)
            {
                this.bDlgError = true;
                this.errorMessage = 'Seleccione un rango de fechas adecuado.'
            }
            else
            if (this.bCountry && this.countryID === 0)
            {
                this.bDlgError = true;
                this.errorMessage = 'Seleccione un país.'
            }
            else
            if (this.bSpecies && this.speciesID === 0)
            {
                this.bDlgError = true;
                this.errorMessage = 'Seleccione una especie.'
            }
            else
            if ((this.membershipID === 0) &&
                (this.registrationDateFrom === null) && 
                (this.registrationDateTo === null) &&
                (this.bPendingVaxes === false) &&
                (this.bPendingDewormings === false) &&
                (this.countryID === 0) &&
                (this.speciesID === 0))
            {
                console.log("Parámetros vacíos.");
                this.bDlgError = true;
                this.errorMessage = 'Seleccione un parámetro de búsqueda.';
            }
            else
            if (this.bPendingVaxes)
            {
                var searchData = {
                    estadoid: this.stateID,
                    paisid: this.countryID,
                }

                console.log("searchData = ", searchData);
                this.$store.dispatch("searchPendingVaxes", searchData);
            }
            else
            if (this.bPendingDewormings)
            {
                var searchData = {
                    estadoid: this.stateID,
                    paisid: this.countryID,
                }

                console.log("searchData = ", searchData);
                this.$store.dispatch("searchPendingDewormings", searchData);
            }
            else
            {
                //validacionesPendientes: this.bPendingValidations, PENDIENTE
                var searchData = {
                    tipomembresiaid: this.membershipID,
                    fecha1: this.registrationDateFrom,
                    fecha2: this.registrationDateTo,
                    paisid: this.countryID,
                    estadoid: this.stateID,
                    especieid: this.speciesID,
                    razaid: this.breedID
                }

                console.log("searchData = ", searchData);
                this.$store.dispatch('searchPets', searchData);
            }
        },

        onPet(){
            //this.showPetDlg = true;
            //console.log("mascotaid = ", this.selectedResult[0].mascotaid);
            this.$store.dispatch('getPet', this.selectedResult[0].mascotaid)
        }

    },
    components:
    {
        Mascota,
    },
    computed:
    {
        ...mapGetters([
            'waitCursor',
            'countries',
            'states',
            'species',
            'breedsSpanish'
        ]),

        petSearchResults: {
            get() {
                return this.$store.getters.petSearchResults;
            },
            set(petSearchResults) {
                this.$store.dispatch('updatePetSearchResults', petSearchResults
                );
            }
        },

        showPetDlg: {
            get() {
                return this.$store.getters.showPetDlg;
            },
            set(showPetDlg) {
                this.$store.dispatch('updateShowPetDlg', showPetDlg
                );
            }
        },

        // style="height: 578px; max-height:100%"
        listHeight() {
            var height;
            if (this.$vuetify.breakpoint.xs) {
                height = '200px';
            } else if (this.$vuetify.breakpoint.sm) {
                height = '700px';
            } else {
                height = '470px';
            }
            return height;
        },

        errorModalWidth() {
            var width = '100%';
            if (this.$vuetify.breakpoint.xs) {
                width = '80%';
            } else if (this.$vuetify.breakpoint.sm) {
                width = '60%';
            } else if (this.$vuetify.breakpoint.md) {
                width = '40%';
            } else if (this.$vuetify.breakpoint.lg) {
                width = '30%';
            } else if (this.$vuetify.breakpoint.xl) {
                width = '20%';
            }
            return width;
        },

        logoHeight() {
            var height;
            if (this.$vuetify.breakpoint.xs) {
                height = '40';
            } else if (this.$vuetify.breakpoint.sm) {
                height = '40';
            } else if (this.$vuetify.breakpoint.md) {
                height = '50';
            } else if (this.$vuetify.breakpoint.lg) {
                height = '60';
            } else {
                height = '80';
            }
            return height;
        },
    },
};
</script>

<style scoped>
.sub-window {
    /* background-color: #e0e0e0; */
    /*grey lighten-2 */
    background: rgba(224, 224, 224, 0.6);
}
.pets {
    background: url('../assets/fondo2.jpg');
    background-size: cover;
    width: 100%;
    height: 100%;
}

.my-list-title {
    font-size: 15px;
    font-weight: bold;
}
.my-list-subtitle {
    font-size: 13px;
    font-weight: bold;
}
.my-list-header {
    font-size: 11px;
    font-weight: bold;
    background-color: #e0e0e0;
}
.my-list-item {
    min-height: 30px !important;
}

/* ***************Modificaciones para que no se parta el texto en v-card-text y en v-card-title (al parecer es un bug de vuetify):************* */
.v-card__text,
.v-card__title {
    word-break: normal; /* maybe !important  */
}
</style>